<template>
  <span
    v-show="rendered"
    class="user"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="size-6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'userIcon',
  serverCacheKey: () => 'userIcon',
  data: () => ({
    rendered: false
  }),

  mounted() {
    this.rendered = true
  }
}
</script>

<style lang="scss">
.user {
  display: inline-block;
  width: 36px;
  height: 36px;
  fill: #fff;
  text-shadow: rgba(0, 0, 0, 0.2) 0px 1px 0px;
  transition: transform 0.2s ease-in-out;
}
</style>
